<template>
    <div class="sanitationRankStatistic">
        <el-row class="query">
            <el-form :model="queryformdata" inline>
                <div>

                    <el-form-item label="日期" style="margin-right: 8px;">
                        <el-date-picker ref="startTime" :clearable="false" v-model="queryformdata.startTime" type="date" value-format="yyyy-MM-dd" @change="startDateChange">
                        </el-date-picker>

                    </el-form-item>
                    <el-form-item label="-" style="margin-right: 40px;">
                        <el-date-picker ref="endTime" :clearable="false" v-model="queryformdata.endTime" type="date" value-format="yyyy-MM-dd" :picker-options="endtimepickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <div style="display: inline-block;margin-top:5px;">
                        <el-button class="reset-btn" type="primary" @click="loadDataInFirstPage">查询</el-button>

                        <el-button class="reset-btn" @click="reset">重置</el-button>
                    </div>
                </div>
                <div style="padding-right: 93px; position: relative">
                    <el-form-item>
                        <ul class="houselist" v-if="role==='housekeeper'"> 
                            <el-input type="radio" v-model="queryformdata.houseId" style="display: none"></el-input>
                            <li v-for="(item, index) in HouseByManagerUserCombobox" :key="index" :class="{active: item.active}" @click="triggerHouseActive(item.houseId)">{{item.houseName}}</li>

                        </ul>
                        <ul class="houselist" v-if="role==='admin' || role === 'logisticsadmin'">
                            <el-input type="radio" v-model="queryformdata.schoolNum" style="display: none"></el-input>
                            <li v-for="(item, index) in schoolAreaList" :key="index" :class="{active: item.active}" @click="triggerHouseActive(item.schoolNum,1)">{{item.schoolName}}</li>
                        </ul>
                        <ul class="houselist" v-if="role==='headmaster'">
                            <el-input type="radio" v-model="queryformdata.classId" style="display: none"></el-input>
                            <li v-for="(item, index) in classAreaList" :key="index" :class="{active: item.active}" @click="triggerHouseActive(item.id,2)">{{item.className}}</li>
                        </ul>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-download" class="export-btn" @click="exportExl">导出记录</el-button>

                </div>
            </el-form>
        </el-row>
        <div class="pie-content" ref="echart" v-show="showEchart">
        </div>
        <el-row class="tablelist">
            <el-table border stripe :data="dataList" header-row-class-name="table-header" style="width: 1200px;">

                <el-table-column type="index" :index="indexMethod" label="排名" width="50" align="center">

                </el-table-column>
                <el-table-column prop="dormitoryName" label="宿舍" width="200" align="center">
                </el-table-column>
                <el-table-column v-if="role!='housekeeper'" prop="houseName" label="楼栋" width="250" align="center">

                </el-table-column>
                <el-table-column v-if="role==='housekeeper'" prop="floorName" label="楼层" width="500" align="center">
                </el-table-column>
                <el-table-column v-if="role==='admin' || role == 'logisticsadmin'" prop="childSchoolName" label="园区" width="250" align="center">
                </el-table-column>
                <el-table-column v-if="role==='headmaster'" prop="studentList" label="学生" width="250" align="center">
                </el-table-column>
                <el-table-column prop="avgScore" label="卫生评级" width="409" align="center">
                    <span slot-scope="scope">
                        <el-rate v-model="scope.row.avgScore" disabled></el-rate>
                        <span :class="scoreROW(scope.row.avgScore).class">({{scoreROW(scope.row.avgScore).text}})</span>
                    </span>
                </el-table-column>

            </el-table>
            <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination" :page="page" :size="size"></v-pagination>

        </el-row>
    </div>
</template>

<script>
import { session } from '@/util'
import api from '@/api';
import basetable from '@/mixins/base-table';


export default {
    components: {
    },
    props: {},
    mixins: [basetable],

    data () {
        let user = session('user');
        let token = session('token').accesstoken;
        let vm = this;
        return {
            user,
            size: 10,
            doNotInit: true,
            role: user.tsr.roleCode,
            token:token,
            queryformdata: {
                houseId: '',
                houseName: '',
                startTime: '',
                endTime: '',
                schoolNum: '',
                classId:'',
            },
            endtimepickerOptions: {
                disabledDate (time) {
                    if (vm.queryformdata.startTime) {
                        return time < new Date(vm.queryformdata.startTime + ' 00:00:00').getTime();
                    }
                    return false;
                },
            },
            HouseByManagerUserCombobox: [],
            schoolAreaList: [],
            classAreaList:[],
            showEchart: false,
        }
    },
    watch: {},
    computed: {

    },
    methods: {
        indexMethod (index) {
            return (this.page - 1) * this.size + index + 1;
        },
        scoreROW (score) {
            if (score > 3) {
                return {
                    class: 'green',
                    text: '优秀'
                }
            }
            if (score === 3) {
                return {
                    class: 'orange',
                    text: '合格'
                }
            } else {
                return {
                    class: 'red',
                    text: '不合格'
                }
            }
        },
        // 部门学校树枝
        deptTreeNodeHandleClick (data, node, c) {
            this.queryformdata.houseId = data.id;
            this.queryformdata.houseName = data.name;
        },
        queryHouseByManagerUser () {
            return api.summary.queryHouseByManagerUser().then(res => {
                if (res.code == 0) {
                    this.HouseByManagerUserCombobox = res.data;
                    return res.data;
                } else {
                    this.$message(res.message);
                }
                return res.data;
            });
        },
        startDateChange (v) {
            this.queryformdata.endTime = v;
        },
        triggerHouseActive (id, type) {
            if (type == '1') {//admin
                this.queryformdata.schoolNum = id;
                this.schoolAreaList.forEach((x) => {
                    x.active = false;
                    if (x.schoolNum === this.queryformdata.schoolNum)
                        x.active = true
                });
            } else if(type == '2'){//headmaster
            	this.queryformdata.classId = id;
                this.classAreaList.forEach((x) => {
                    x.active = false;
                    if (x.id === this.queryformdata.classId)
                        x.active = true
                });
            }else{//housekeeper
                this.queryformdata.houseId = id;
                this.HouseByManagerUserCombobox.forEach((x) => {
                    x.active = false;
                    if (x.houseId === this.queryformdata.houseId)
                        x.active = true
                });
            }

            this.loadDataInFirstPage();
        },
        loadDataInFirstPage () {
            this.page === 1 ? this.loadData() : this.page = 1;
        },
        sub(str){
        	return str.length>10?str.substring(0,10)+'...':str
        },
        loadData () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            var roleType = this.role === 'admin' || this.role == 'logisticsadmin'? 1 : this.role === 'housekeeper' ? 2 : this.role === 'headmaster' ? 3 : '';
			console.log(this.user)
            let param = {
                schoolId: this.user.schoolId,
                houseId: this.queryformdata.houseId,
                schoolNum: this.queryformdata.schoolNum,
                startDate: this.queryformdata.startTime || undefined,
                endDate: this.queryformdata.endTime || undefined,
                classId:this.queryformdata.classId,
                roleType:roleType,
            };
            api.sanitationManage.houseHealthTotal(param, this.page, 10).then((res) => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.total;
                    const dataList = ((list = new Array())=>{
                    	for(var i = 0;i<data.list.length;i++){
                    		const item = data.list[i]
                    		item.avgScore = parseInt(item.avgScore)
                    		list.push(item)
                    	}                    	
                    	return list 
                    })()
                    
                    this.dataList = dataList;
                    var xData = [], seriesData = [];

                    // 生成图表,只生成前10名的图片.
                    if (this.page === 1) {
                        var length = this.size > 10 ? 10 : this.size;
                        var list = data.list.slice(0, length);
                        list.forEach((item) => {
                            if (this.role === 'admin' || this.role == 'logisticsadmin') {
								xData.push(this.sub(item.dormitoryName) + "\n" + this.sub(item.childSchoolName) +"\n" + this.sub(item.houseName));
                            } else if (this.role === 'housekeeper') {
                                xData.push(this.sub(item.dormitoryName));
                            }else if (this.role === 'headmaster') {
                                xData.push(this.sub(item.houseName)+"\n"+ this.sub(item.dormitoryName));
                            }
                            seriesData.push(item.avgScore);
                            item.avgScore = parseInt(item.avgScore);

                        })
                        if (seriesData.length > 0) {
                            this.showEchart = true;
                            var echartOptions = {
                                xAxis: {
                                    name: '宿舍',
                                    type: 'category',
                                    data: xData,
                                    
                                    axisLabel: {
                                        interval: 0,
                                        rotate: xData.length > 6 ? -30 : 0,
                                        align:'center',
                                        margin:20,
                                    }
                                },
                                grid: [{ bottom: '20%' ,left:'40',right:'60'}],
                                yAxis: {
                                    type: 'value',
                                    name: '评级',
                                    nameLocation: 'end',
                                    min:0,
                                    max:5,
                                    axisLabel: {
                                        formatter: function (value,index) {
                                            var texts = [];
                                            if (value == 0) {
                                                texts.push(' ');
                                            }
                                            else if (value == 1) {
                                                texts.push('一星');
                                            }
                                            else if (value <= 2) {
                                                texts.push('二星');
                                            }
                                            else if (value <= 3) {
                                                texts.push('三星');
                                            }
                                            else if (value <= 4) {
                                                texts.push('四星');
                                            }
                                            else {
                                                texts.push('五星');
                                            }
											return texts

                                        }
                                    }
                                },
                                series: [{
                                    data: seriesData,
                                    type: 'bar',
                                    barMaxWidth: '20px',
                                    itemStyle: {
                                        normal: {
                                            color: '#ffb324'
                                        }
                                    }
                                }]

                            }

                            var myChart = this.$echarts.init(this.$refs.echart);
                            myChart.setOption(echartOptions);
                        } else {
                            this.showEchart = false
                        }
                    }

                } else {
                    this.$message(res.message);
                }
            });
        },
        reset () {
        	var queryformdata = {
                	houseId: '',
                    houseName: '',
                    schoolNum: '',
                    startTime: this._setCurrentTime(),
                    endTime: this._setCurrentTime(),
                    classId:'',
                };
			 if (this.role === 'headmaster') {	
			 	var classId;
                if (this.classAreaList && this.classAreaList.length > 0) {
                	 this.classAreaList.forEach((x,index) => {
	                 	x.active = false;
	                    if (index == 0)
	                    x.active = true
	                });
                    classId = this.classAreaList[0].id;
                }
                queryformdata.classId = classId
                this.queryformdata = queryformdata
                this.loadData();
           }else if (this.role === 'admin' || this.role == 'logisticsadmin') {	
			 	var schoolNum;                
                if (this.schoolAreaList && this.schoolAreaList.length > 0) {
                	this.schoolAreaList.forEach((x,index) => {
	                    x.active = false;
	                    if (index === 0)
	                     	x.active = true
	                });
                    schoolNum = this.schoolAreaList[0].schoolNum;
                }
                queryformdata.schoolNum = schoolNum
                this.queryformdata = queryformdata
                this.loadData();
           }else{
           		var houseId;                
                if (this.HouseByManagerUserCombobox && this.HouseByManagerUserCombobox.length > 0) {
                	this.HouseByManagerUserCombobox.forEach((x,index) => {
	                    x.active = false;
	                    if (index === 0)
	                     	x.active = true
	                });
                    houseId = this.HouseByManagerUserCombobox[0].houseId;
                }
                queryformdata.houseId = houseId
                this.queryformdata = queryformdata
                this.loadData();
            }
        },
        // 返回当天年月日
        _setCurrentTime () {
            let date = new Date();
            let year = date.getFullYear();
            let month = this._padZero(date.getMonth() + 1);
            let day = this._padZero(date.getDate());
            return [year, month, day].join("-");
        },
        _padZero (str) {
            let start = str.length == 2 ? 0 : 1;
            return ("0" + str).substring(start);
        },
        exportExl () {
            if (this.queryformdata.startTime === '' && this.queryformdata.endTime) {
                this.$message('请选择开始时间!');
                return;
            }
            if (this.queryformdata.endTime === '' && this.queryformdata.startTime) {
                this.$message('请选择结束时间!');
                return;
            }
            var roleType = this.role === 'admin' || this.role == 'logisticsadmin'? 1 : this.role === 'housekeeper' ? 2 : this.role === 'headmaster' ? 3 : '';
			
            let param = {
                schoolId: this.user.schoolId,
                houseId: this.queryformdata.houseId || undefined,
                startDate: this.queryformdata.startTime || undefined,
                endDate: this.queryformdata.endTime || undefined,
                roleType:roleType,
                classId:this.queryformdata.classId,
                schoolNum: this.queryformdata.schoolNum,
            };
            api.sanitationManage.houseHealthTotalExport(param, this.page, 10).then(response => {
                let blob = new Blob([response], { type: 'application/x-xls' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = '卫生排名统计.xls';
                link.click()
            })
        },
        getSchoolarealist () {
            return api.summary.querySchoolCapmus().then(res => {
                if (res.code == 0) {
                    this.schoolAreaList = res.data;
                    return res.data;
                } else {
                    this.$message(res.message)
                }
            })
        },
        //根据班主任获取班级
        getClassarealist(){
        	return api.systemConfig.qryMasterClasses(this.token).then(res => {
                if (res.code == 0) {
                    this.classAreaList = res.data;
                    return res.data;
                } else {
                    this.$message(res.message)
                }
            })
        }
    },
    created () {
        this.queryformdata.startTime = this._setCurrentTime();
        this.queryformdata.endTime = this._setCurrentTime();
        if (this.role === 'housekeeper') {
            this.queryHouseByManagerUser().then(data => {
                this.queryformdata.houseId = this.HouseByManagerUserCombobox[0].houseId;
                this.HouseByManagerUserCombobox[0].active = true;
                this.loadData();
            })
        }
        if (this.role === 'admin' || this.role == 'logisticsadmin') {
            this.getSchoolarealist().then(data => {
                this.schoolAreaList.unshift({ schoolNum: '', schoolName: '全部', active: true });
                this.loadData();
            });
        }
         if (this.role === 'headmaster') {
            this.getClassarealist().then(data => {            	
	            this.queryformdata.classId = this.classAreaList[0].id;
	            this.classAreaList[0].active = true
                this.loadData();
            });
        }

    },
    mounted () { }
}
</script>
<style lang="scss" >
.sanitationRankStatistic {
  .green {
    color: #00cdcd;
  }
  .orange {
    color: #ffb324;
  }
  .red {
    color: red;
  }
  .query {
    margin-top: 20px;
  }
  .el-rate {
    display: inline-block;
    vertical-align: middle;
    & + span {
      font-size: 14px;
    }
  }
  .houselist {
    li {
      display: inline-block;
      vertical-align: top;
      min-width: 72px;
      height: 30px;
      line-height: 30px;
      margin-right: 59px;
      margin-bottom: 10px;
      padding: 0 10px;
      border: 1px solid #dbdbdb;
      border-radius: 4px;
      color: #333;
      text-align: center;
      cursor: pointer;
      &.active {
        color: #26aef3;
        border: 1px solid #26aef3;
      }
    }
  }
  .pie-content {
    width: 1036px;
    height: 600px;
    margin: 0 auto;
  }
  .export-btn {
    position: absolute;
    right: 0;
    border: 1px solid #26aef3;
    color: #26aef3;
    background-color: #fff;
  }
  .el-button {
    min-width: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/sanitationManage/sanitationRankStatistic.vue